import { InvestorSplitOption } from '@willow/graphql-iso/src/app';
import { InvestorRemittanceSplit } from '@willow/types-iso';

import { assertNever } from './assertNever';

export const investorSplitToInvestorRemittanceSplit = (type: InvestorSplitOption): InvestorRemittanceSplit => {
  switch (type) {
    case InvestorSplitOption.Investor:
      return {
        splitEnabled: true,
        investor: 100,
        servicer: 0,
      };
    case InvestorSplitOption.Servicer:
      return {
        splitEnabled: true,
        investor: 0,
        servicer: 100,
      };
    case InvestorSplitOption.FiftyFifty:
      return {
        splitEnabled: true,
        investor: 50,
        servicer: 50,
      };
    default:
      assertNever(type);
  }
};

export const investorRemittanceSplitToInvestorSplit = (
  investorRemittanceSplit: InvestorRemittanceSplit,
): InvestorSplitOption | undefined => {
  if (!investorRemittanceSplit.splitEnabled) {
    return undefined;
  }
  if (investorRemittanceSplit.investor === 100) {
    return InvestorSplitOption.Investor;
  }
  if (investorRemittanceSplit.servicer === 100) {
    return InvestorSplitOption.Servicer;
  }
  return InvestorSplitOption.FiftyFifty;
};
